import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconQueue = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.75 7C5.75 6.58579 5.41421 6.25 5 6.25C4.58579 6.25 4.25 6.58579 4.25 7V17C4.25 17.4142 4.58579 17.75 5 17.75C5.41421 17.75 5.75 17.4142 5.75 17V7Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 6.25C10.4142 6.25 10.75 6.58579 10.75 7V17C10.75 17.4142 10.4142 17.75 10 17.75C9.58579 17.75 9.25 17.4142 9.25 17V7C9.25 6.58579 9.58579 6.25 10 6.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4697 6.46967C14.7626 6.17678 15.2374 6.17678 15.5303 6.46967L19.8232 10.7626C20.5066 11.446 20.5066 12.554 19.8232 13.2374L15.5303 17.5303C15.2374 17.8232 14.7626 17.8232 14.4697 17.5303C14.1768 17.2374 14.1768 16.7626 14.4697 16.4697L18.7626 12.1768C18.8602 12.0791 18.8602 11.9209 18.7626 11.8232L14.4697 7.53033C14.1768 7.23744 14.1768 6.76256 14.4697 6.46967Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconQueue as ReactComponent };
